import {BaseContainerModel} from '../base-container.model';
import {bl_applet_client_side_perm_dfn_RowClass} from '../../dbschema';

export class ClientSidePermissionContainerModel extends BaseContainerModel {
    bl_applet_client_side_perm_dfn: bl_applet_client_side_perm_dfn_RowClass = new bl_applet_client_side_perm_dfn_RowClass();
}
